import './App.css';
import HomePage from './HomePage/HomePage';
import ClientInstance from './ClientInstance/ClientInstance';
import AdminConsole from './AdminConsole/AdminConsole';
import ClientConsole from './ClientInstance/ClientConsole';
import SignUp from './HomePage/SignUp';
import SetPassword from './Config/SetPassword';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import {useEffect, useState} from 'react';
import {Context} from './Context';

function App() {
  // DISPLAY
  const [screenWidth, setWidth]   = useState(window.innerWidth);
  const [screenHeight, setHeight] = useState(window.innerHeight);

  // SCREEN DIMENSIONS
  const updateDimensions = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
  };
  
  useEffect(() => {   // DISPLAY CHANGE HOOK
      window.addEventListener("resize", updateDimensions);
      return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // Context
  const contextObject = {
    screenWidth:screenWidth,
    screenHeight:screenHeight,
  };

  return (
    <Context.Provider value={contextObject}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/adminConsole/" element={<AdminConsole />} />
          <Route path="/console/" element={<ClientConsole />} />
          <Route path="/signup/" element={<SignUp />} />
          <Route path="/config/setPassword/:sessionId/:userId" element={<SetPassword />} />
          <Route path="/:clientInstance/" element={<ClientInstance />} />
        </Routes>
      </BrowserRouter>
    </Context.Provider>
  );
}

export default App;
